import { h } from 'preact'; // h is required for JSX transform
import { useState, useRef, useEffect } from 'preact/hooks';
import { OrthomolIcon } from '../../components-common/OrthomolIcon';
import { AboBenefitsList } from '../common/AboBenefitsList';

export const CartItemAboLabel = ({ deliveryText = null }: { deliveryText?: string | null }) => {
  const [tooltipPos, setTooltipPos] = useState<{ top: number; left: number } | null>(null);
  const btnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!tooltipPos) return;
    const close = () => setTooltipPos(null);
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [tooltipPos]);

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (tooltipPos) {
      setTooltipPos(null);
      return;
    }
    const rect = (btnRef.current as HTMLButtonElement).getBoundingClientRect();
    const tooltipWidth = 260;
    const margin = 8;
    // Position above the button, right-aligned to it, clamped within viewport.
    // getBoundingClientRect() and position:fixed are both viewport-relative — no scroll offset needed.
    let left = rect.right - tooltipWidth;
    left = Math.max(margin, Math.min(left, window.innerWidth - tooltipWidth - margin));
    const top = rect.top - margin; // CSS transform handles the -100% upward shift
    setTooltipPos({ top, left });
  };

  return (
    <span className="cart-abo-label d-inline-flex align-items-center gap-1">
      <small className="fw-semibold">Im Abo</small>
      <button
        ref={btnRef}
        className="btn p-0 border-0 bg-transparent text-primary lh-1 d-inline-flex align-items-center"
        aria-label="Abo-Informationen"
        onClick={handleClick}
      >
        <OrthomolIcon name="info-circle-16" size="16" viewBox="0 0 16 16" />
      </button>
      {tooltipPos && (
        <div
          className="abo-info-tooltip"
          role="tooltip"
          style={{ position: 'fixed', top: tooltipPos.top, left: tooltipPos.left }}
          onClick={(e) => e.stopPropagation()}
        >
          <button className="abo-info-tooltip-close btn p-0 border-0 bg-transparent" onClick={() => setTooltipPos(null)} aria-label="Schließen">
            <OrthomolIcon name="cross-24" size="16" />
          </button>
          <AboBenefitsList deliveryText={deliveryText} />
        </div>
      )}
    </span>
  );
};
